import dayjs from 'dayjs';

import { COMMON_REQUEST_DATE_FORMAT } from 'constants/date';
import { jsonParse } from 'utils/json';
import { formatNumberToFixed2DecimalsExceptNull } from 'utils/number';

import {
  currencyFieldName,
  dateFieldName,
} from './LoanChangesHistoryTable/LoanChangesHistoryTable.constants';

export const normalizeLoanChangesValue = loanChangesValue => {
  try {
    const parsed = jsonParse(loanChangesValue);

    if (!Array.isArray(parsed)) {
      return loanChangesValue;
    }

    if (!parsed.length) {
      return '';
    }

    return parsed
      .map(obj =>
        Object.entries(obj)
          .map(([key, value]) => {
            if (currencyFieldName.includes(key)) {
              return `${key}: $${formatNumberToFixed2DecimalsExceptNull(value)}`;
            }

            if (dateFieldName.includes(key)) {
              return `${key}: ${dayjs(value).format(COMMON_REQUEST_DATE_FORMAT)}`;
            }

            return `${key}: ${value}`;
          })
          .join(' '),
      )
      .join('; ');
  } catch {
    return loanChangesValue;
  }
};
